import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ProductHeadingDivider from './ProductHeadingDivider';

import NavLink from './nav_link';
// import all nav lists
import CliList from './cli-links/cliList';
import FGWListnav from './fgwLinks/fgwList--top';

const styles = (theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        textAlign: 'left',
    },
    productHeading: {
        fontWeight: 'bold',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1rem',
    },
    subheading: {
        maxHeight: '48px',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1rem',
        lineHeight: '1.46429em',
    },
    subheadingActive: {
        maxHeight: '40px',
        color: 'rgba(0, 0, 0, 0.95)',
        fontSize: '1rem',
        lineHeight: '1.46429em',
        paddingTop: '1.0rem',
    },
    chevron: {
        fill: '#262626',
        marginRight: '-1rem',
    },
});

class FlightList extends React.Component {
    state = {
        openFgw: false,
        openFCli: false,
    };
    handleClickFgw = (event) => {
        let current = !this.state.openFgw;
        if (!event) {
            current = true;
        }
        this.setState({
            openFgw: current,
        });
    };
    handleClickFCli = (event) => {
        let current = !this.state.openFCli;
        if (!event) {
            current = true;
        }
        this.setState({
            openFCli: current,
        });
    };
    preventAction = (e) => {
        e.preventDefault();
    };

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <List>
                    {/* */}
                    <NavLink onClick={this.preventAction} to="/flight/gateway">
                        <ListItem button onClick={this.handleClickFgw} className={classes.subheading}>
                            <ListItemText secondary="Flight Gateway" />
                            {this.state.openFgw ? (
                                <ExpandLess className={classes.chevron} />
                            ) : (
                                <ExpandMore className={classes.chevron} />
                            )}
                        </ListItem>
                        <ProductHeadingDivider />
                    </NavLink>
                    <FGWListnav
                        isOpen={this.state.openFgw}
                        onActive={this.handleClickFgw}
                        handleDrawerToggle={this.props.handleDrawerToggle}
                    />

                    <NavLink onClick={this.preventAction} to="/flight/cli">
                        <ListItem button onClick={this.handleClickFCli} className={classes.subheading}>
                            <ListItemText secondary="Flight CLI" />
                            {this.state.openFCli ? (
                                <ExpandLess className={classes.chevron} />
                            ) : (
                                <ExpandMore className={classes.chevron} />
                            )}
                        </ListItem>
                        <ProductHeadingDivider />
                    </NavLink>
                    <CliList
                        isOpen={this.state.openFCli}
                        onActive={this.handleClickFCli}
                        handleDrawerToggle={this.props.handleDrawerToggle}
                    />
                </List>
            </React.Fragment>
        );
    }
}

FlightList.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(FlightList);
